import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  gradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    backgroundImage: `linear-gradient(transparent 0%, ${theme.palette.gradientColors.blue})`
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/Gradient/styles.js